import contactForm from '@/api/contact_forms'

export default ({ commit, state }, param) => {
  return new Promise((resolve, reject) => {
    commit('setContactFormSort', param)

    contactForm.setContactFormSort(result => {
      resolve(result.data.status)
    }, state.list.detail)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/actions/setContactFormSort.js